module.exports = __webpack_public_path__ + "img/cloud-rain-lightning.a96a1787.svg";